export default __webpack_public_path__ + "static/media/emoji-face.fda86138.svg";